import { withStyles } from '@material-ui/core/styles'
import React, { useEffect } from 'react'
import styles from './styles'

import { useDispatch, useSelector } from 'react-redux'
import {
  ShareViewHeader,
  ShareView,
  EmbedView,
  ShareLinkCourse,
  EmbedViewCourse,
  IframeViewCourse,
  PdfCourse,
  ScormView,
} from './components'
import { useLocation } from 'react-router-dom'
import { getCourseByIdAction, getCourseLandingPageAction } from 'src/reducers/course/action'
import { useSnackbar } from 'notistack'
import { useCoursePublish } from 'src/contexts/course-publish-context'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'
import MessageBoxContent, {
  MessageBoxType,
  MessageBoxVariant,
} from 'src/model/message-box'
import { ButtonData, ButtonType, ButtonActionType } from 'src/model/button'
import { track } from '@amplitude/analytics-browser'
const SharePopover = props => {
  const { classes } = props
  const location = useLocation()
  const coursePage = location.pathname.includes('course')

  const [view, setView] = React.useState(
    coursePage ? 'share-course' : 'share-collection',
  )
  const course = useSelector(state => state.course.course)

  useEffect(() => {
    if (coursePage) {
      dispatch(getCourseByIdAction(course.id, response => {}))
      dispatch(getCourseLandingPageAction(course.id))
    }
  }, [course])

  const dispatch = useDispatch()
  const handleView = view => {
    setView(view)
  }

  const publishState = useCoursePublish()
  const { enqueueSnackbar } = useSnackbar()

  /**
   * Moving back to draft asks for confirmation where publish does not: its
   * effect is outward-facing and immediate — anyone holding the link loses
   * access the moment it lands.
   */
  const handleUnpublish = () => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [
            new ButtonData(
              ButtonType.NORMAL,
              'Cancel',
              ButtonActionType.NO,
              () => dispatch(messageBoxHideAction()),
            ),
            new ButtonData(
              ButtonType.ACTION,
              'Move to draft',
              ButtonActionType.DELETE,
              async () => {
                try {
                  await publishState.unpublishCourse()
                  track('course_unpublished')
                  enqueueSnackbar(
                    'Moved to draft. Learners no longer see it.',
                    { variant: 'success' },
                  )
                } catch (error) {
                  enqueueSnackbar('Could not move this course to draft.', {
                    variant: 'error',
                  })
                } finally {
                  dispatch(messageBoxHideAction())
                }
              },
            ),
          ],
          title: 'Move this course back to draft?',
          subTitle: null,
          description:
            'Learners lose access right away and the share link stops working. Content and learner progress are kept, so you can publish it again later.',
          // Without a cap the box is fit-content, so this description sets the width and the modal
          // stretches into one very wide line. 500px is what the other text confirmations use.
          maxWidth: '500px',
          variant: MessageBoxVariant.NOTICE,
        }),
      ),
    )
  }

  const selectedCollection = useSelector(
    state => state.courseCollectionList.selectedCollection,
  )
  const collection = useSelector(state =>
    state.courseCollectionList.list.courseCollectionDtos.filter(
      collection => collection.id === selectedCollection,
    ),
  )
  const me = useSelector(state => state.authentication.me)

  const collectionComponents = [
    {
      component: (
        <ShareView
          entity={collection[0]}
          dispatch={dispatch}
          handleView={handleView}
        />
      ),
      onView: view == 'share-collection',
      mainPage: true,
    },
    {
      component: <EmbedView entity={collection[0]} handleView={handleView} />,
      onView: view == 'embed-collection',
      mainPage: true,
    },
  ]
  const courseComponents = [
    {
      component: (
        <ShareLinkCourse
          handleView={handleView}
          me={me}
          canMoveToDraft={Boolean(publishState?.isPublished)}
          onMoveToDraft={handleUnpublish}
        />
      ),
      onView: view == 'share-course',
      mainPage: true,
    },
    {
      component: <EmbedViewCourse handleView={handleView} />,
      onView: view == 'embed-course',
      mainPage: true,
    },
    {
      component: <IframeViewCourse handleView={handleView} />,
      onView: view == 'iframe-course',
      mainPage: true,
    },
    {
      component: <PdfCourse handleView={handleView} me={me} />,
      onView: view == 'pdf-course',
      mainPage: true,
    },
    {
      component: <ScormView handleView={handleView} me={me} />,
      onView: view == 'scorm-course',
      mainPage: true,
    },
  ]

  return (
    <div className={classes.content}>
      <div className={classes.content__components}>
        <ShareViewHeader view={view} handleView={handleView} />
        {coursePage
          ? courseComponents.map(
              (component, index) =>
                component.onView && (
                  <div key={index}>{component.component}</div>
                ),
            )
          : collectionComponents.map(
              (component, index) =>
                component.onView && (
                  <div key={index}>{component.component}</div>
                ),
            )}
      </div>
    </div>
  )
}

export default withStyles(styles)(SharePopover)
